import '../../Clients/Dialogs/CreateEditDialog/Tabs/Fields/NotificationsTab/NotificationsTab.scss';

import { Field, useFormikContext } from 'formik';
import { Checkbox } from 'primereact/checkbox';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getNotificationChannel,
  getNotificationType,
} from '../../../../utils/constants/entities/notifications';
import FieldWithErrors from '../../../Forms/FieldWithErrors/FieldWithErrors';

function NotificationsForm() {
  const { t } = useTranslation();
  const notificationType = useMemo(() => getNotificationType(t), [t]);
  const notificationChannel = useMemo(() => getNotificationChannel(t), [t]);

  const { values } = useFormikContext();
  console.log('NotificationsForm ', values);
  return (
    <div className="notifications-page">
      <FieldWithErrors name="notification" label={false}>
        <div className="notification-head">
          <span>{t('Notification type')}</span>

          {notificationChannel.map((nChannel) => (
            <span key={nChannel.id} title={nChannel.description}>
              {nChannel.title}
            </span>
          ))}
        </div>

        <div className="notifications-page">
          {notificationType.map((nType) => (
            <div key={nType.id} className="notification">
              <span title={nType.description}>{nType.title}</span>

              {notificationChannel.map((nChannel) => {
                const id = `${nType.id}-1-${nChannel.id}`;
                return (
                  <Field
                    key={id}
                    name={`${id}.isChecked`}
                    as={Checkbox}
                    checked={values[id]?.isChecked ?? false}
                  />
                );
              })}
            </div>
          ))}
        </div>
      </FieldWithErrors>
    </div>
  );
}

export default NotificationsForm;
